import type { MembershipProject } from "@zworks/console-contracts";
import { ZotChat } from "@/components/zot-chat";
import { Sheet, SheetContent, SheetDescription, SheetTitle } from "@/components/ui/sheet";
import { CommandPalette } from "./command-palette";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import type { CommandSurface } from "./use-command-surface";

export function CommandDialogs({
  surface,
  onClose,
  project,
  pageContext,
  onOpenZot,
}: {
  surface: CommandSurface;
  onClose: () => void;
  project: MembershipProject | null;
  pageContext: string;
  onOpenZot: () => void;
}) {
  return (
    <>
      <Dialog open={surface === "search"} onOpenChange={(open) => !open && onClose()}>
        <DialogContent className="top-[12vh] p-0">
          <DialogTitle className="sr-only">Pages and actions</DialogTitle>
          <DialogDescription className="sr-only">
            Search pages, runs, and actions in this project.
          </DialogDescription>
          <CommandPalette onClose={onClose} onOpenZot={onOpenZot} />
        </DialogContent>
      </Dialog>
      <Sheet open={surface === "zot"} onOpenChange={(open) => !open && onClose()}>
        <SheetContent
          side="right"
          aria-label="Ask Zot"
          className="flex h-full w-[min(32rem,100%-2rem)] max-w-none flex-col gap-0 p-0 sm:max-w-none"
        >
          <SheetTitle className="sr-only">Ask Zot</SheetTitle>
          <SheetDescription className="sr-only">
            Project assistant chat. Answers are scoped to your project and role.
          </SheetDescription>
          <ZotChat project={project} pageContext={pageContext} className="h-full" />
        </SheetContent>
      </Sheet>
    </>
  );
}
